import i18next from 'i18next';

import commonEs from './common/es/index.json';
import commonEn from './common/en/index.json';
import commonPt from './common/pt/index.json';
import commonFr from './common/fr/index.json';
import commonDe from './common/de/index.json';
import commonNl from './common/nl/index.json';
import commonDk from './common/dk/index.json';
import commonSe from './common/se/index.json';
import commonNo from './common/no/index.json';
import commonRu from './common/ru/index.json';
import commonPl from './common/pl/index.json';
import commonIt from './common/it/index.json';
import commonCz from './common/cz/index.json';
import commonRo from './common/ro/index.json';
import commonFi from './common/fi/index.json';
import commonIs from './common/is/index.json';
import commonTr from './common/tr/index.json';
import commonGb from './common/gb/index.json';
import commonArb from './common/arb/index.json';
import commonCn from './common/cn/index.json';
import commonIn from './common/in/index.json';
import commonJp from './common/jp/index.json';
import commonKr from './common/kr/index.json';

import ekEn from './ek/en/index.json';
import { LanguageNamespaces, LANGUAGE_NAMESPACE } from '@constants/language';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: LANGUAGE_NAMESPACE,
  fallbackNS: LanguageNamespaces.Common,
  ns: [LanguageNamespaces.Common, LANGUAGE_NAMESPACE],
  resources: {
    en: {
      common: commonEn,
      ek: ekEn,
    },
    es: {
      common: commonEs,
    },
    pt: {
      common: commonPt,
    },
    fr: {
      common: commonFr,
    },
    de: {
      common: commonDe,
    },
    nl: {
      common: commonNl,
    },
    dk: {
      common: commonDk,
    },
    se: {
      common: commonSe,
    },
    no: {
      common: commonNo,
    },
    ru: {
      common: commonRu,
    },
    pl: {
      common: commonPl,
    },
    it: {
      common: commonIt,
    },
    cz: {
      common: commonCz,
    },
    ro: {
      common: commonRo,
    },
    fi: {
      common: commonFi,
    },
    is: {
      common: commonIs,
    },
    tr: {
      common: commonTr,
    },
    gb: {
      common: commonGb,
    },
    arb: {
      common: commonArb,
    },
    cn: {
      common: commonCn,
    },
    in: {
      common: commonIn,
    },
    jp: {
      common: commonJp,
    },
    kr: {
      common: commonKr,
    },
  },
});

export default i18next;
